import styled from "@emotion/styled";
import { Navigate, Route, Routes } from "react-router";
import { BrowserRouter as Router } from "react-router-dom";
import { PageRegister } from "screens/register/page-register";
import { RestaurantNotify } from "screens/restaurant/resturant-notify";
import { useEffect, useState } from "react";
import { getLanguage, getNavPath } from "auth-provider";
import { LabelType } from "screens/register/page-header";
import { RestaurantCard } from "screens/restaurant/reataurant-card";
import { useAuth } from "context/auth-context";
import { useHttp } from "utils/http";
import { APP_API_URL } from "screens/register/util";
import { defaultHeaders } from "utils/request";
import { useWindowSize } from "utils";

export const AuthenticatedApp = () => {
  const [lang, setLang] = useState(getLanguage() as LabelType);
  const client = useHttp();

  const { restaurant: restaurantData } = useAuth();

  const { width: currentWidth, height: currentHeight } = useWindowSize();

  const saveRestaurant = (addressInfo: any) => {
    client(`${APP_API_URL}/api/v1/restaurant_details`, {
      method: "post",
      headers: defaultHeaders,
      data: {
        restaurant_id: restaurantData.data.id,
        name: restaurantData.data.attributes.name,
        foreign_name: restaurantData.data.attributes.foreign_name,
        address_1: addressInfo?.attributes?.address_1,
        city: addressInfo?.attributes?.city,
        state: addressInfo?.attributes?.state,
        zip_code: addressInfo?.attributes?.zip_code,
        latitude: addressInfo?.attributes?.latitude,
        longitude: addressInfo?.attributes?.longitude,
        wallet_icon_2x_url: restaurantData.data.attributes?.wallet_icon_2x_url,
        wallet_icon_url: restaurantData.data.attributes?.wallet_icon_url,
        wallet_logo_url: restaurantData.data.attributes?.wallet_logo_url,
        wallet_strip_2x_url:
          restaurantData.data.attributes?.wallet_strip_2x_url,
        wallet_strip_url: restaurantData.data.attributes?.wallet_strip_url,
      },
    })
      .then((data) => {
        if (data || data.success) {
        }
      })
      .catch((e) => { });
  };

  const restaurantAddress = restaurantData?.included;
  if (restaurantAddress) {
    const addressInfo = restaurantAddress.find(
      (item: any) => item?.type === "address"
    );
    if (!addressInfo) {
      return null;
    }
    saveRestaurant(addressInfo);
  }

  // eslint-disable-next-line react-hooks/rules-of-hooks
  useEffect(() => {
    let restaurantDataAttribute = restaurantData?.data?.attributes;
    let restaurantName = restaurantDataAttribute?.name || '';
    let restaurantLogoURL = restaurantDataAttribute?.wallet_logo_url || restaurantDataAttribute?.wallet_icon_2x_url || '';
    let linkElement = document.head.querySelector(`link[rel="icon"]`);
    let linkAppleTouchIconElement = document.head.querySelector(`link[rel="apple-touch-icon"]`);
    let tileDOM = document.head.querySelector("title");
    if (restaurantLogoURL && linkElement) {
      (linkElement as HTMLLinkElement).setAttribute('href', restaurantLogoURL)
    }
    if (restaurantLogoURL && linkAppleTouchIconElement) {
      (linkAppleTouchIconElement as HTMLLinkElement).setAttribute('href', restaurantLogoURL)
    }
    if (restaurantName && tileDOM) {
      (tileDOM as HTMLTitleElement).innerText = `${restaurantName} | Loyalty | Chowbus POS`
    }

  }, [restaurantData]);

  return (
    <Container lang={lang}>
      <Router>
        <Main currentWidth={currentWidth} currentHeight={currentHeight}>
          <Routes>
            <Route
              path={"/member"}
              element={<PageRegister setLang={setLang} />}
            ></Route>
            <Route path={"/notify"} element={<RestaurantNotify />}></Route>
            <Route
              path={"/restaurant"}
              element={<RestaurantCard setLang={setLang} />}
            ></Route>
            <Route
              path="*"
              element={<Navigate to={`${getNavPath("member")}`}></Navigate>}
            ></Route>
          </Routes>
        </Main>
      </Router>
    </Container>
  );
};

const Container = styled.div<{
  lang: LabelType;
}>`
  font-family: ${(props) =>
    props.lang === "zh" ? "PingFang SC" : "Proxima Nova"};
  height: 100%;
`;

const Main = styled.main<{
  currentWidth: Number;
  currentHeight: Number;
}>`
  width: ${(props) =>
    props.currentWidth > 480 ? "48rem" : props.currentWidth + "px"};
  min-height: ${(props) => props.currentHeight + "px"};
  margin: 0 auto;
  display: flex;
  flex-direction: column;
`;
